import React from 'react'

function HospitalLocation() {
  return (
    <div className='w-full mt-4'>
        <h1 className='text-3xl font-bold ml-8 text-center'>Our Location </h1>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.0196147512092!2d75.65659807462977!3d14.59795817714231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb97e3115adfa9f%3A0xf951d42afe6e46e1!2sShri%20Tharalabaalu%20Jagadguru%20Institute%20of%20Technology%20%7C%7C%20KIADB%20Industrial%20Area%20%7C%7C%20Raanebennur!5e0!3m2!1sen!2sin!4v1730215924048!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='hospital'
        className='w-full px-4 py-4 rounded-3xl'></iframe>
    </div>
  )
}
 
export default HospitalLocation